import { render, staticRenderFns } from "./EditMain.vue?vue&type=template&id=56e5ac8b&"
import script from "./EditMain.vue?vue&type=script&lang=js&"
export * from "./EditMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports